import React, { useState } from 'react';
import { Avatar, Card, CardContent, Checkbox, Container, Dialog, DialogTitle, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, ListItemAvatar, ListItemText, Typography } from "@mui/material";
// import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { Facebook, Google, Twitter } from "@mui/icons-material";
import Div from "@jumbo/shared/Div";
import { alpha } from "@mui/material/styles";
import { ASSET_IMAGES, BACKEND_APP_URL } from "../../utils/constants/paths";
import { getAssetPath } from "../../utils/appHelpers";
import * as yup from "yup";
import { Form, Formik } from "formik";
import JumboTextField from "@jumbo/components/JumboFormik/JumboTextField";
import LoadingButton from "@mui/lab/LoadingButton";
import authServices from "../../services/auth-services";
import { Link, useNavigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { storeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';
import { setAuthToken } from 'app/services/auth/jwtAuth';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { blue } from '@mui/material/colors';
import JumboAppContext from '@jumbo/components/JumboApp/JumboAppContext';
import Logo from 'app/shared/Logo';
import { useEffect } from 'react';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import JumboItemCheckbox from '@jumbo/components/JumboList/components/JumboItemCheckbox';
import axios from 'axios';
const validationSchema = yup.object().shape({
    fname: yup.string().required('First name is required'),
    lname: yup.string().required('Last name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    pass: yup.string().required('Password is required').min(6, 'Password must be at least 6 characters'),
    cpass: yup.string().required('Confirm Password is required').oneOf([yup.ref('pass'), null], 'Passwords must match'),
    ccode: yup.string().required('Country code is required').matches(/^\+\d+$/, 'Invalid country code format'),
    mobile: yup.string().required('Mobile number is required').matches(/^[0-9]+$/, 'Invalid mobile number').min(6),  
    cname: yup.string().required('Company name is required'),
    country: yup.string().required('Country is required'),
    city: yup.string().required('City is required'),
    state: yup.string().required('state is required'),
    // pin: yup.string().required('Pin code is required'),
    address: yup.string().required('Address is required'),
    tnc: yup.boolean().oneOf([true], 'You must accept the terms and conditions')
});


const UserRegister = () => {
    // const {setAuthToken} = useJumboAuth();
    // console.log(setAuthToken);
    const [userData, setUserData] = useState({})
    const [openDialoge, setOpenDialoge] = useState(false);
    const [loading, setloading] = useState(false);
    const navigate = useNavigate();
    const jumboco = useJumboAuth()
    const swal = useSwalWrapper()
    const onSignUP = (data) => {
        setloading(true)
        axios.post(BACKEND_APP_URL+'user/addnewuser',data)
            .then((res) => {
                // console.log(data);
                if (res.data.status =='success') {
                    // setUserData(data)
                    swal.fire({
                        icon:'success',
                        text:res.data.message,
                      })  
                      navigate("/registerThankyou");
                    
                    // setOpenDialoge(true)
                }
                // setAuthToken(data.user);
            }).catch((e) => {
                console.log(e);
                swal.fire({
                    icon:'error',
                    text:'Invalid Detail',
                  })  
            }).finally(()=>{
                setloading(false)
            });
    };
    const branchSelctHandler = (branch) => {
        // console.log(branch);
        jumboco.setAuthOptions({ type: "start-loading" });
        authServices.signIn({ token:userData.user.token,branchCode:branch.FL_BRANCH_CODE,COID:branch?.FL_COMPANY_CODE }).then(async resData=>{
            // setUserData({...userData.user,token:resData.token})
            setAuthToken({...userData.user,branches:userData.branch,currentBranch:branch,token:resData.token});
            jumboco.setAuthToken(JSON.stringify({...userData.user,branches:userData.branch,currentBranch:branch,token:resData.token}))
            jumboco.setAuthOptions({ type: "stop-loading" });
            navigate("/dashboard");
            // console.log(userData);  
        });
        // console.log(jumboco);
    }
    // useEffect(()=>{
    //     console.log(userData);
    // },[userData])
    return (<>
        <Container>
            <Card
                sx={{
                    display: 'flex',
                    minWidth: 0,
                    flexDirection: { xs: 'column', md: 'row' }
                }}
            >
                {/* <CardContent
                    sx={{
                        flex: '0 1 300px',
                        position: 'relative',
                        background: `#0267a0 url(${getAssetPath(`${ASSET_IMAGES}/widgets/keith-luke.jpg`, "640x428")}) no-repeat center`,
                        backgroundSize: 'cover',

                        '&::after': {
                            display: 'inline-block',
                            position: 'absolute',
                            content: `''`,
                            inset: 0,
                            backgroundColor: alpha('#0267a0', .65)
                        }
                    }}
                >
                    <Div
                        sx={{
                            display: 'flex',
                            minWidth: 0,
                            flex: 1,
                            flexDirection: 'column',
                            color: 'common.white',
                            position: 'relative',
                            zIndex: 1,
                            height: '100%'
                        }}
                    >
                        <Div sx={{mb: 2}}>
                            <Typography variant={"h3"} color={"inherit"} fontWeight={500} mb={3}>Sign In</Typography>
                            <Typography variant={"body1"} mb={2}>
                                By signing in, you can avail full features of the Jumbo.
                            </Typography>
                        </Div>

                        <Div sx={{mt: 'auto'}}>
                            <Link href="#" underline="none" sx={{display: 'inline-flex'}}>
                                <img src={`${ASSET_IMAGES}/logo-white.png`} alt="Jumbo React"/>
                            </Link>
                        </Div>
                    </Div>
                </CardContent> */}
                <CardContent sx={{ flex: 1, p: 3 }}
                >
                    <div style={{display: 'block',margin: '0 auto',textAlign: 'center',maxWidth: '300px'}}><Logo /></div>
                    <Formik
                        validateOnChange={true}
                        initialValues={{
                            fname: '',
                            lname: '',
                            email: '',
                            pass: '',
                            ccode: '',
                            mobile: '',
                            cname: '',
                            country: '',
                            country: '',
                            city: '',
                            state: '',
                            pin: '',
                            address: '',
                            tnc: false,
                        }}
                        validationSchema={validationSchema}
                        onSubmit={async (data, { setSubmitting }) => {
                            setSubmitting(true);
                            await onSignUP(data);
                            setSubmitting(false);
                        }}
                    >
                        {({ isSubmitting,touched,errors,setFieldValue }) => (
                            <Form style={{ textAlign: 'left' }} noValidate autoComplete='off'>
                                <Div sx={{ mt: 2, mb: 3 }}>
                                <Typography variant='h3' sx={{mb:2}}>Login Information</Typography>
                                    <Grid  container spacing={2}>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="fname"
                                            label="First Name"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="lname"
                                            label="Last Name"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="email"
                                            type="email"
                                            label="Email"
                                        />
                                    </Grid>
                                    <Grid  item xs={4} lg={2}>
                                        <JumboTextField
                                            fullWidth
                                            autoComplete= "off"
                                            name="ccode"
                                            label="County code"
                                        />
                                    </Grid>
                                    <Grid  item xs={8} lg={4}>
                                        <JumboTextField
                                            fullWidth
                                            name="mobile"
                                            label="Mobile"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="pass"
                                            label="Password"
                                            type="password"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="cpass"
                                            type="password"
                                            label="confirm Password"
                                        />
                                    </Grid>
                                    </Grid>
                                </Div>
                                <Typography variant='h3' sx={{mb:2}}>Business Information</Typography>
                                <Grid  container spacing={2}>
                                    <Grid  item xs={12} lg={12}>
                                        <JumboTextField
                                            fullWidth
                                            name="cname"
                                            label="Company Name *"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="country"
                                            label="County *"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="state"
                                            label="State *"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="city"
                                            label="City *"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={6}>
                                        <JumboTextField
                                            fullWidth
                                            name="pin"
                                            label="Pin Code"
                                        />
                                    </Grid>
                                    <Grid  item xs={12} lg={12}>
                                        <JumboTextField
                                            fullWidth
                                            name="address"
                                            label="Address"
                                        />
                                    </Grid>
                                    </Grid>
                                <Div sx={{ pb: 3,mt:2,display: 'flex',justifyContent: 'space-between' }}>
                                    {/* <FormControlLabel control={<Checkbox/>} label="Terms "/> */}
                                    <Div> <Checkbox
                                            onChange={(e)=>setFieldValue( "tnc", e.target.checked)}
                                            name="tnc"
                                            id="tnc"
                                        />
                                    <InputLabel htmlFor="tnc" sx={{display:'inline'}}>I have read and accept </InputLabel><Link to={'/t&c'} style={{color:'black'}}>Terms and Conditions.</Link>
                                    {errors.tnc && touched.tnc && (
                            <Typography color="error">{errors.tnc}</Typography>
                        )}
                                    </Div>
                                    <Link to={'/login'}>Already have an account? Log In</Link>
                                    {/* <Link>Forgot password</Link> */}
                                </Div>
                                <LoadingButton
                                    type="submit"
                                    variant="contained"
                                    size="large"
                                    sx={{ mb: 3 ,mx:'auto',display:'block'}}
                                    loading={loading}
                                >Register</LoadingButton>
                            </Form>
                        )}
                    </Formik>
                </CardContent>
            </Card>
        </Container>
        {/* <Dialog onClose={() => setOpenDialoge(!openDialoge)} open={openDialoge}>
            <DialogTitle>Select Branch account</DialogTitle>
            <List sx={{ pt: 0, minWidth: 400 }}>
                {userData.branch && userData.branch.map((branch) => (
                    <ListItem button onClick={() => branchSelctHandler(branch)} key={branch.FL_BRANCH_CODE}>
                        <ListItemAvatar>
                            <Avatar
                                sx={{ bgcolor: '#060611', color: '#fff' }}
                                alt={branch.FL_BRANCH_CODE}
                                icon={<BusinessOutlinedIcon />}
                            />
                        </ListItemAvatar>
                        <ListItemText primary={`${branch.FL_BRANCH_CODE}(${branch.FL_BRANCH_CITY})`} />
                    </ListItem>
                ))}
            </List>
        </Dialog> */}
    </>
    );
};

export default UserRegister;
